logit.classes.TableEditableData = function(tableId, tableEditableItems) {
    'use strict';

    this.tableId = tableId;
    this.tableEditableItems = tableEditableItems;
}